/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planner_Failed_BudgetInputs */

const en_planner_failed_budget = /** @type {(inputs: Planner_Failed_BudgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This month’s AI budget is used up.`)
};

const de_planner_failed_budget = /** @type {(inputs: Planner_Failed_BudgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das KI-Budget für diesen Monat ist aufgebraucht.`)
};

/**
* | output |
* | --- |
* | "This month’s AI budget is used up." |
*
* @param {Planner_Failed_BudgetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const planner_failed_budget = /** @type {((inputs?: Planner_Failed_BudgetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planner_Failed_BudgetInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_planner_failed_budget(inputs)
	return en_planner_failed_budget(inputs)
});